<template>
    <div id="airwayModeDiv" class="airway-mode-item">

        <div id="squareOutlineAirwayDiv" class="airway-mode-item toggle-div"
            v-on:click.stop="switchSquareOutlineAirway($event)">
            <input id="squareOutlineAirwayButton" type="checkbox" class="toggle-airway-button" checked />
            <div id="squareOutlineAirwayLabel" class="toggle-title">SQUARE OUTLINE</div>
        </div>

        <div id="lineViewAirwayDiv" class="airway-mode-item toggle-div" v-on:click.stop="switchLineViewAirway($event)">
            <input id="lineViewAirwayButton" type="checkbox" class="toggle-airway-button" />
            <div class="toggle-title">LINE VIEW</div>
        </div>

        <div id="cutSliceAirwayDiv" class="airway-mode-item toggle-div" v-on:click.stop="switchCutSliceAirway($event)">
            <input id="cutSliceAirwayButton" type="checkbox" class="toggle-airway-button" />
            <div id="cutSliceAirwayLabel" class="toggle-title">CUT AT SLICE</div>
        </div>

    </div>
</template>

<script>

import {
    switchSquareOutline,
    switchLineView,
    switchCutSlice
} from "./AirwayMode.js";

export default {
    name: "AirwayTopControls",
    props: {
        airwaysData: {
            type: Object,
            required: true
        }
    },
    data() {
        return {};
    },
    methods: {
        switchSquareOutlineAirway: function () {
            switchSquareOutline();
        },
        switchLineViewAirway: function () {
            switchLineView();
        },
        switchCutSliceAirway: function () {
            switchCutSlice();
        }
    },
    mounted: function () {
        canecode_switch(".toggle-airway-button");
        switchToggle('squareOutlineAirwayDiv', this.airwaysData.isSquareOutline);
        switchToggle('lineViewAirwayDiv', this.airwaysData.isLineView);
        switchToggle('cutSliceAirwayDiv', this.airwaysData.isCutSlice);
    }
};
</script>

<style scoped>
.airway-mode-item {
    position: absolute;
}

/* .toggle-div {
    width: 100px;
} */

#airwayModeDiv {
    left: calc(50% - 180px);
    top: 20px;
    width: 350px;
    color: white;
}

#squareOutlineAirwayDiv {
    left: calc(50% - 125px);
}

#squareOutlineAirwayLabel {
    margin-left: -20px;
}

#lineViewAirwayDiv {
    left: calc(50% - 5px);
}

#cutSliceAirwayDiv {
    left: calc(50% - 63px);
    top: 75px;
}

#cutSliceAirwayLabel {
    margin-left: -10px;
}
</style>